<template>
	<b-container class="show-document">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back')
					}}
				</b-button>

			</div>
			<div class="pull-right">
				<b-form-checkbox
					v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' "
					class="mt-3 mr-2"
					id="checkbox-1"
					v-model="viewPrices"
					name="checkbox-1"
					value="accepted"
					button-variant="outline-success"
					unchecked-value="not_accepted"
					button
				>
					Показать все цены
				</b-form-checkbox>
				<b-button
					variant="outline-primary"
					@click="excelExport('whDocTable', item.regNumber)"
					class="mr-2"
				>
					{{ $t('excel-export.download-excel') }}
				</b-button>
				<b-button
					variant="outline-dark"
					@click="generateBarcode"
					class="mr-2"
					v-if="item.documentStatus === 'READY'"
				>
					<i class="fa fa-print"></i>
					{{ $t('pricing.print') }} {{ $t('goods.barcode') }}
				</b-button>
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{ $t('pricing.print') }}
				</b-button>
				<b-button
					v-if="item.editable"
					@click="openSidebar"
					variant="outline-dark"
					class="mr-2"
				>
					<i class="fa fa-edit"></i>
					{{ $t('Изменить') }}
				</b-button>
				<!--<b-button
					v-if="item.editable"
					@click="showConfirm(item.id)"
					variant="outline-danger"
					:key="item.id + 'delete'"
					:id="'popOverDelete'+item.id"
				>
					<i class="fa fa-trash"></i>
					{{ $t('Delete') }}
				</b-button>
				<b-popover
					:key="item.id + 'popover'"
					:target="'popOverDelete'+item.id"
					placement="bottom"
					:ref="'popover'+item.id"
					class="refDeleteConfirm"
				>
					<template slot="title">
						<b-button @click="closeConfirm(item.id)" class="close" aria-label="Close"
								  style="margin-left: 5px">
							<span class="d-inline-block" aria-hidden="true">&times;</span>
						</b-button>
						{{ $t('want_to_delete?') }}
					</template>

					<div>
						<div class="row mt-1">
							<div class="col-6">
								<b-button variant="outline-danger" size="sm" block @click="closeConfirm(item.id)">
									{{$t('No') }}
								</b-button>
							</div>
							<div class="col-6">
								<b-button variant="outline-success" size="sm" block @click="remove">{{ $t('Yes') }}
								</b-button>
							</div>
						</div>
					</div>
				</b-popover>-->
				<!--<div class="pull-right ml-2 pt-2">
					<b-form-group>
						<b-form-checkbox-group switches disabled v-model="income" name="switches1"
											   :options="[{text: 'Income', value: true}]"/>
					</b-form-group>
				</div>-->
				<!--<div class="pull-right ml-2">
					<b-form-group>
						<b-form-radio-group
							id="btnradios1"
							buttons
							v-model="priceType"
							button-variant="outline-primary"
							:options="[
						{
						text: 'Сум',
						value: 'uzs'
						},
						{
						text: 'USD',
						value: 'usd'
						},

					]"
							name="radiosBtnDefault"
						/>
					</b-form-group>
				</div>-->
				<!--				<div class="clearfix"></div>-->
			</div>
			<div class="clearfix"></div>

		</div>

		<b-modal
			:title="$t('barcode-count')"
			v-model="confirmBarcodeGenerate"
			@ok=""
			size="lg"
		>

			<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
				<thead>
				<tr>
					<th>&#9745;</th>
					<th style="width: 30px;text-align: center">№</th>
					<th>{{ $t('sidebar.warehouse-management.products') }}</th>
					<th colspan="2">{{ $t('goods.amount') }}</th>
					<!--<th style="width: 230px;">Количество</th>-->
				</tr>
				</thead>
				<tr cols="12" v-for="(calculateCount,index) in currentWhItems">
					<td>
						<b-checkbox v-model="calculateCount.checked"></b-checkbox>
					</td>
					<td style="text-align: center">
						{{ index + 1 }}
					</td>
					<td>{{ calculateCount.itemName }} / <strong> {{ calculateCount.artikul }} </strong>/
						{{ calculateCount.color }} /{{ calculateCount.size }}
						<strong>{{ calculateCount.barcode }}</strong></td>
					<td>
						<b-col>
							<b-input-group size="sm">
								<b-form-input v-model="calculateCount.count"
											  size="sm" autocomplete="off" type="number"
											  :disabled="!calculateCount.checked"
								></b-form-input>
							</b-input-group>
						</b-col>
					</td>
				</tr>
			</table>

			<div slot="modal-footer">
				<b-button
					variant="success"
					size="sm"
					class="float-right ml-2"
					@click="submitBarcodeGenerate"
				>
					{{ $t('save') }}
				</b-button>

				<b-button
					variant="primary"
					size="sm"
					class="float-right"
					@click="cancelBarcodeGenerate"
				>
					{{ $t('cancel') }}
				</b-button>
			</div>
		</b-modal>

		<div class="doc-body">
			<b-card class="p-3">
				<b-row class="mb-3">
					<b-col></b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center day-wrapper">
							{{ formatDate(item.regDate, 'DD') }}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center ">
							{{ formatDate(item.regDate, 'MM') }}
						</div>
					</b-col>
					<b-col cols="1">
						<div class="w-100 underline text-center">
							{{ formatDate(item.regDate, 'YYYY') }}
						</div>
					</b-col>
				</b-row>
				<div class="text-center">
					<h3 class="font-weight-bold text-uppercase">{{ $t(item.documentType) }} №: <span
						class="small">{{ item.regNumber }}</span>
					</h3>
				</div>
				<div class="text-right">
					<p>
						<strong>{{ $t('incomes.create.to-warehouse') }}:</strong> {{ item.toDepartmentName }}
					</p>
					<p>
						<strong>Вес:</strong> {{ updateWeight(item) }}

					</p>
					<p v-if="item.responsible1Name">
						<strong>{{ $t('incomes.responsible') }}:</strong>
						{{ item.responsible1Name }} <br>
						<span v-if="item.responsible1Name">{{ item.responsible2Name }}</span>
					</p>
					<p v-if="item.reason">
						<strong>{{ $t('incomes.reason') }}:</strong> {{ item.reason }}
					</p>
				</div>

				<b-row class="mb-2">
					<b-col cols="4" v-if="item.fromEmployeeName">
						<strong>{{ $t('incomes.create.from') }}:</strong> <u class="underline ml-3">&nbsp; &nbsp;
						{{ item.fromEmployeeName }}
						&nbsp; &nbsp;
					</u>
					</b-col>
					<b-col v-if="item.toEmployeeName">
						<strong>{{ $t('incomes.create.to') }}:</strong> <u class="underline ml-3">&nbsp; &nbsp;
						{{ item.toEmployeeName }}
						&nbsp; &nbsp;
					</u>
					</b-col>
				</b-row>
				<div class="generalTableClass documentItems">
					<table class="table table-striped" id="whDocTable">
						<thead>
						<tr>
							<th class="p-1"> №</th>
							<th class="p-1">{{ $t('goods.barcode') }}</th>
							<th class="p-1">{{ $t('goods.artikul') }}</th>
							<th class="p-1">{{ $t('goods.color') }}</th>
							<th class="p-1">{{ $t('goods.size') }}</th>
							<th class="p-1">{{ $t('incomes.create.product') }}</th>
							<th class="p-1">{{ $t('goods.create.unit') }}</th>
							<!--<th v-if="incomeField && priceType === 'usd'" class="p-1">{{$t('Incoming Price USD')}}</th>-->
							<!--							<th v-if="priceType === 'usd'" class="p-1">{{$t('incomes.create.price')}}</th>-->
							<th v-if="priceType === 'uzs' && viewPrices=='not_accepted'  && (item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && item.action !== 'SPISAT') && !item.fromDepartmentId && isAdmin"
								class="p-1">{{ $t('incomes.create.incoming-price') }}
							</th>
							<!-- //Yangi qo'shildi moldova uchun faqat KOSHIRISH bo'limi -->
							<th v-if="viewPrices == 'accepted' && item.action === 'KOCHIRISH'">
								{{ $t('warehouse.table.priceUzs') }}
							</th>
							<th v-if="viewPrices == 'accepted' && item.action === 'KOCHIRISH'">
								{{ $t('warehouse.table.priceWholesale') }}
							</th>
							<!-- // -->
							<th v-else-if="priceType === 'uzs' && item.action !== 'KIRIM'" class="p-1">
								{{ $t('incomes.create.price') }}
							</th>
							<th class="p-1" style="width: 6%; text-align: center;">{{ $t('sale.kol-vo') }}</th>
							<!-- <th style="text-align: center">{{$t('pos.inWrapped')}}</th>
							<th style="text-align: center">{{$t('pos.inWrappedTotal')}}</th> -->
							<th class="p-1 "
								v-if="(item.action === 'KIRIM' && isAdmin) || (item.action !== 'KIRIM') &&  viewPrices == 'not_accepted'">
								{{ $t('total-amount') }}
							</th>
							<!-- //Yangi qo'shildi moldova uchun faqat KOSHIRISH bo'limi -->
							<th class="p-1 text-center" v-if="item.action === 'KOCHIRISH' && viewPrices == 'accepted'">
								{{ $t('total-amount-retail-price') }}
							</th>
							<th class="p-1 text-center" v-if="item.action === 'KOCHIRISH' && viewPrices == 'accepted'">
								{{ $t('total-amount-wholesale-price') }}
							</th>
							<!-- // -->
						</tr>
						</thead>
						<tbody>
						<tr v-for="(whItem,index) in item.whItems" :key="whItem.id + 'field'" v-if="whItem.count > 0">
							<td class="p-1">{{ index + 1 }}</td>
							<td class="p-1">{{ whItem.barcode ? whItem.barcode : '-' }}</td>
							<td class="p-1">{{ whItem.artikul ? whItem.artikul : '-' }}</td>
							<td class="p-1">{{ whItem.color ? whItem.color : '-' }}</td>
							<td class="p-1">{{ whItem.size ? whItem.size : '-' }}</td>
							<td class="p-1">{{ whItem.itemName ? whItem.itemName.substring(0, 30) : '-' }}</td>
							<td class="p-1">{{ whItem.unitName }}</td>
							<!--<td class="p-1" v-if="incomeField && priceType === 'usd'">
								{{ whItem.incomingPriceUsd | currency({symbol: 'USD', symbolPosition: 'back'}) }}
							</td>-->
							<!--<td v-if="priceType === 'usd'" class="p-1">
								<span v-if="whItem.priceUsd">{{ whItem.priceUsd | currency({symbol: 'USD', symbolPosition: 'back'}) }}</span>
							</td>-->
							<td v-if="priceType === 'uzs' &&
							 			item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && item.action !== 'SPISAT' && !item.fromDepartmentId && isAdmin"
								class="p-1"
							>
								<span v-if="whItem.incomingPriceUzs > 0">{{
										whItem.incomingPriceUzs | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<td v-else-if="priceType === 'uzs' && item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && item.action !== 'SPISAT' && !item.fromDepartmentId && isAdmin"
								class="p-1">
								-
							</td>
							<!-- /// -->
							<td v-else-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && viewPrices == 'not_accepted'"
								class="p-1">
								<span v-if="whItem.priceUzs > 0">{{
										whItem.saleTypePrice | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<!-- //Yangi qo'shildi moldova uchun faqat KOSHIRISH bo'limi -->
							<td v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && viewPrices == 'accepted' "
								class="p-1">
								<span v-if="whItem.priceUzs > 0">{{
										whItem.priceUzs | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<td v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && viewPrices == 'accepted' "
								class="p-1">
								<span v-if="whItem.priceWholesale > 0">{{
										whItem.priceWholesale | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<!-- // -->
							<td v-else-if="priceType === 'uzs' && item.action == 'SPISAT'"
								class="p-1"
							>
								<span v-if="whItem.saleTypePrice > 0">{{
										whItem.saleTypePrice | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<td class="p-1" style="width: 6%; text-align: center; font-weight: bold;">{{
									whItem.count
								}}
							</td>
							<!-- <td style="text-align: center">{{ whItem.wrapped ? getWrappedItemsAmount(whItem.wrappedItems) : 1 }}</td>
							<td style="text-align: center">{{ whItem.wrapped ? getWrappedItemsAmount(whItem.wrappedItems) * whItem.count : whItem.count }}</td> -->
							<!--<td v-if="priceType === 'usd'" class="p-1">
								<span v-if="whItem.priceUsd">{{ whItem.priceUsd * whItem.count | currency({symbol: 'USD', symbolPosition: 'back'}) }}</span>
							</td>-->
							<td v-if="priceType === 'uzs' &&
							 			item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && item.action !== 'SPISAT' && !item.fromDepartmentId && isAdmin"
								class="p-1"
							>
								<span v-if="whItem.incomingPriceUzs * whItem.incomingPriceUzs > 0">{{
										whItem.incomingPriceUzs * whItem.count | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>

							<td v-else-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && viewPrices == 'not_accepted'"
								class="p-1">
								<span v-if="whItem.priceUzs * whItem.priceUzs > 0">{{
										whItem.saleTypePrice * whItem.count | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>

							<!-- //Yangi qo'shildi moldova uchun faqat KOSHIRISH bo'limi -->
							<td v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && viewPrices == 'accepted'"
								class="p-1 text-center">
								<span v-if="whItem.priceUzs * whItem.count> 0">{{
										whItem.priceUzs * whItem.count | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<td v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && viewPrices == 'accepted'"
								class="p-1 text-center">
								<span v-if="whItem.priceWholesale * whItem.count > 0">{{
										whItem.priceWholesale * whItem.count | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
							<!-- // -->

							<td v-else-if="priceType === 'uzs' && item.action == 'SPISAT'" class="p-1">
								<span v-if="whItem.saleTypePrice * whItem.saleTypePrice > 0">{{
										whItem.saleTypePrice * whItem.count | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>
						</tr>
						</tbody>

						<tfoot>
						<tr>
							<td
								v-if="priceType === 'uzs' && item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && item.action !== 'SPISAT' && !item.fromDepartmentId"
								:colspan="item.action === 'KIRIM' && !isAdmin?'6':'7'"
								class="p-1 pr-3"
								style="text-align: right;"
							>
								<strong class="font-lg">Итого</strong>
							</td>
							<td
								v-else
								:colspan="viewPrices=='not_accepted'?'7':'8'"
								class="p-1 pr-3"
								style="text-align: right;"
							>
								<strong class="font-lg">Итого</strong>
							</td>
							<td class="p-1" style="text-align: center; font-weight: bold; vertical-align: middle;">
								{{ totalCount }}
							</td>

							<!-- <td class="p-1"
								style="text-align: center; vertical-align: middle; font-weight: bold;">
								-
							</td>
							<td class="p-1" style="text-align: center; font-weight: bold; vertical-align: middle;">
								{{ getTotalWrappedItemsAmount > 0 ? getTotalWrappedItemsAmount : '-' }}
							</td> -->

							<td class="p-1" v-if="priceType === 'uzs' &&
							 			item.action !== 'CHIQIM' && item.action !== 'KOCHIRISH' && item.action !== 'SPISAT' && !item.fromDepartmentId && isAdmin">
								<span v-if="totalIncome.uzs > 0">{{
										totalIncome.uzs | currency({
											symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
											fractionCount: 2,
											symbolPosition: 'back'
										})
									}}</span>
								<span v-else>-</span>
							</td>

							<td class="p-1"
								v-else-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && totalPrice.uzs > 0 && viewPrices == 'not_accepted' "
								style="vertical-align: middle; font-weight: bold;">
								{{
									totalPrice.saleTypePrice | currency({
										symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
										fractionCount: 2,
										symbolPosition: 'back'
									})
								}}
							</td>


							<td class="p-1"
								v-else-if="priceType === 'uzs' && item.action == 'SPISAT' && totalPrice.saleTypePrice > 0 && item.action !== 'KIRIM' "
								style="vertical-align: middle; font-weight: bold;">
								{{
									totalPrice.saleTypePrice | currency({
										symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
										fractionCount: 2,
										symbolPosition: 'back'
									})
								}}
							</td>

							<td class="p-1"
								v-else-if="priceType === 'uzs' && item.action !== 'KIRIM' && viewPrices == 'not_accepted' "
								style="vertical-align: middle; font-weight: bold;">
								-
							</td>
							<!-- //Yangi qo'shildi moldova uchun faqat KOSHIRISH bo'limi -->
							<td class="p-1 text-center"
								v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && totalPrice.uzs > 0 && viewPrices == 'accepted' "
								style="vertical-align: middle; font-weight: bold;">
								{{
									totalPrice.priceUzs | currency({
										symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
										fractionCount: 2,
										symbolPosition: 'back'
									})
								}}
							</td>
							<td class="p-1  text-center"
								v-if="priceType === 'uzs' && item.action !== 'SPISAT' && item.action !== 'KIRIM' && totalPrice.uzs > 0 && viewPrices == 'accepted' "
								style="vertical-align: middle; font-weight: bold;">
								{{
									totalPrice.priceWholesale | currency({
										symbol: (item.fromDepCurrencyName && item.action !== 'KIRIM') ? item.fromDepCurrencyName : item.toDepCurrencyName,
										fractionCount: 2,
										symbolPosition: 'back'
									})
								}}
							</td>
							<!-- // -->
						</tr>
						</tfoot>
					</table>
					<div v-if="loader" class="spinner-wrapper">
						<b-spinner variant="primary"></b-spinner>
					</div>
				</div>
				<div>
					<div class="d-flex justify-content-end">
						<label class="control-label font-weight-bold">{{ $t('comment') }}:</label>
						<p class="ml-1">{{ item.comment }}</p>
					</div>
				</div>
			</b-card>
		</div>
		<vs-sidebar :click-not-close="true"
					position-right
					parent="body"
					default-index="1"
					color="primary"
					class="create-modal"
					spacer
					v-model="sidebar.open">
			<b-container index="1" v-if="sidebar.open">
				<create-form
					:mode="'edit'"
					:edit-item="item"
					@close="sidebar.open = false"
					@reload="get"
				></create-form>
			</b-container>
		</vs-sidebar>
	</b-container>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import WhDocument from "../../../../services/wh-document.service";
import moment from 'moment'
import UsersService from "../../../../services/users.sevice";
import CreateForm from "../blocks/CreateForm";

export default {
	name: 'Show',
	data() {
		return {
			viewPrices: 'not_accepted',
			loader: false,
			item: {},
			totalPrice: {
				uzs: 0,
				usd: 0,
				saleTypePrice: 0,
				priceWholesale: 0,
				priceUzs: 0
			},
			priceType: 'uzs',
			income: [],
			totalIncome: {
				uzs: 0,
				usd: 0
			},
			confirmBarcodeGenerate: false,
			barcodeCount: 0,
			currentWhItems: [],
			sidebar: {
				open: false,
				close: false
			},
			backTo: null,
		}
	},

	methods: {
		...mapActions('warehouse', [
			'setFromIncomeToTransfer', 'setCurrentWhItems'
		]),
		getWrappedItemsAmount(wrappedItems) {
			let inWrappedAmount = 0;
			if (wrappedItems) {
				wrappedItems.forEach(item => inWrappedAmount += item.amount)
			}
			return inWrappedAmount;
		},
		updateWeight(item) {
			if (item.sumWeightAllItems > 1000) {
				return item.sumWeightAllItems / 1000 + ' кг';
			}
			if (item.sumWeightAllItems < 1000) {
				return item.sumWeightAllItems + ' гр';
			}
			if (item.sumWeightAllItems > 1000000) {
				return item.sumWeightAllItems / 1000000 + ' тонна';
			}
		},
		get() {
			if (this.$can('get', 'warehouse-document')) {
				this.loader = true;
				return WhDocument.get(this.$route.params.id).then(response => {
					this.loader = false;
					this.item = response.data;
					this.sumPrice(this.item);
					this.sumIncome(this.item);
				}).catch(error => {
					this.loader = false
				})
			}
		},
		sumPrice(item) {
			if (typeof item.whItems === 'object') {
				Object.values(item.whItems).map(item => {
					if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;
					if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;
					if (item.saleTypePrice) this.totalPrice.saleTypePrice += item.saleTypePrice ? item.saleTypePrice * item.count : 0;
					if (item.priceUzs) this.totalPrice.priceUzs += item.priceUzs ? item.priceUzs * item.count : 0;
					if (item.priceWholesale) this.totalPrice.priceWholesale += item.priceWholesale ? item.priceWholesale * item.count : 0;
				});
			}
		},
		sumIncome(item) {
			if (typeof item.whItems === 'object') {
				Object.values(item.whItems).map(item => {
					this.totalIncome.usd += item.incomingPriceUsd * item.count;
					this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
				});
			}
		},
		formatDate(date, format = 'DD-MM-YYYY') {
			if (date) {
				const split = date.split(' ');
				date = split[0];
				const revers = date.split('-');
				date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
				return moment(String(date)).format(format)
			}
		},
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		openSidebar() {
			setTimeout(() => {
				this.sidebar.open = true
			}, 200)
		},

		generateBarcode() {
			//this.currentWhItems = Object.assign({}, this.item.whItems);
			this.currentWhItems = JSON.parse(JSON.stringify(this.item.whItems));
			this.confirmBarcodeGenerate = true;
			//this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);

		},
		cancelBarcodeGenerate() {
			this.confirmBarcodeGenerate = false;
		},
		submitBarcodeGenerate() {
			let items = {};
			items.status = true;
			items.data = this.currentWhItems.filter(column => column.checked === true);
			items.data.forEach((item, index) => {
				items.data[index].count = parseInt(item.count)
			});
			this.setCurrentWhItems(items);
			this.$router.push(`/warehouse-management/income/barcodes`);
		},

		remove() {
			WhDocument.remove(this.item.id).then(response => {
				this.$router.push('/warehouse-management/income');
			})
		},

		showConfirm(item) {
			let refName = 'popover' + item;
			this.$refs[refName].$emit('open')
		},
		closeConfirm(item) {
			let refName = 'popover' + item;
			this.$refs[refName].$emit('close')
		},
		excelExport(table, fileName = '') {


			var uri = 'data:application/vnd.ms-excel;base64,'
				,
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
				, base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				}
				, format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
				, downloadURI = function (uri, name) {
					var link = document.createElement("a");
					link.download = name;
					link.href = uri;
					link.click();
				}

			if (!table.nodeType) table = document.getElementById(table)
			var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
			var resuri = uri + base64(format(template, ctx))
			downloadURI(resuri, fileName);
		},


	},
	created() {
		this.get();
	},
	computed: {
		...mapState(['isAdmin']),
		/*incomeField() {
			return this.income[0]
		},*/
		getTotalWrappedItemsAmount() {
			let temp = 0;
			if (this.item.whItems) {
				this.item.whItems.forEach(el => {
					if (el.wrapped) {
						if (el.wrappedItems) {
							el.wrappedItems.forEach(item => {
								temp += item.amount * el.count;
							})
						}
					} else {
						temp += el.count;
					}
				})
			}
			return temp;
		},
		totalCount() {
			let sum = 0;
			if (this.item.whItems) {
				if (this.item.whItems.length > 0) {
					this.item.whItems.forEach(el => {
						sum += el.count;
					});
				}
			}
			return sum;
		}
	},
	components: {
		CreateForm
	},
}
</script>

<style scoped lang="scss">
@media print {
	.hidden-print {
		display: none;
	}

	.card {
		box-shadow: none;
	}
}

.generalTableClass {
	.table {
		td, th {
			font-size: 12px;
		}
	}
}

.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}
</style>
